import type { Video } from "@/types/video";

export const videos: Video[] = [
  {
    id: "wandering-earth-3",
    title: "流浪地球3",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20sci-fi%20movie%20poster%20of%20a%20lone%20astronaut%20silhouette%20before%20a%20colossal%20planetary%20engine%2C%20deep%20dark%20space%2C%20warm%20orange%20rim%20light%2C%20epic%20scale%2C%20moody%20atmosphere%2C%20high%20detail&width=400&height=600&seq=ng-poster-01&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=Epic%20cinematic%20sci-fi%20landscape%20of%20a%20giant%20planetary%20engine%20tower%20on%20a%20frozen%20earth%20against%20a%20dark%20starry%20sky%2C%20warm%20orange%20glow%2C%20dramatic%20scale%2C%20high%20detail%20wide%20shot&width=1600&height=900&seq=ng-banner-01&orientation=landscape",
    category: "电影",
    genres: ["科幻", "动作"],
    region: "国产",
    year: 2025,
    director: "郭帆",
    cast: ["吴京", "刘德华", "李雪健"],
    updateDate: "2025-10-12",
    rating: 9.1,
    summary:
      "太阳急速老化，地球面临被吞没的危机。人类倾尽所有建造万座行星发动机，推着家园驶向未知的宇宙深处。面对命运的重重考验，一群人用勇气与信念，为蓝色星球寻找最后的生机。",
    featured: true,
    latest: true,
    hot: true,
  },
  {
    id: "changan-30000",
    title: "长安三万里",
    poster:
      "https://readdy.ai/api/search-image?query=Chinese%20ink%20wash%20animation%20movie%20poster%20of%20an%20ancient%20poet%20riding%20a%20horse%20through%20misty%20mountains%20at%20golden%20sunset%2C%20elegant%20traditional%20art%20style%2C%20warm%20tones%2C%20high%20detail&width=400&height=600&seq=ng-poster-02&orientation=portrait",
    category: "电影",
    genres: ["动画", "历史"],
    region: "国产",
    year: 2024,
    director: "谢君伟",
    cast: ["杨天翔", "凌振赫", "路知行"],
    updateDate: "2025-09-28",
    rating: 8.8,
    summary:
      "大唐盛世之下，高适与李白的相识与重逢跨越数十载。从意气风发到命运沉浮，两位诗人的一生映照着一个王朝的兴衰，也写尽了中国人骨子里的浪漫与豪情。",
    latest: true,
    hot: true,
  },
  {
    id: "lost-in-breeze",
    title: "消失的她",
    poster:
      "https://readdy.ai/api/search-image?query=Suspense%20thriller%20movie%20poster%20with%20silhouette%20of%20a%20woman%20standing%20by%20a%20dark%20ocean%20cliff%2C%20moody%20deep%20shadows%2C%20single%20warm%20orange%20light%2C%20cinematic%20high%20detail&width=400&height=600&seq=ng-poster-03&orientation=portrait",
    category: "电影",
    genres: ["悬疑", "犯罪"],
    region: "国产",
    year: 2024,
    director: "崔睿",
    cast: ["朱一龙", "倪妮", "文咏珊"],
    updateDate: "2025-09-20",
    rating: 8.2,
    summary:
      "一场甜蜜的异国旅行，却成了妻子离奇失踪的噩梦起点。当真相被层层谎言包裹，丈夫的每一次自证都让他更像嫌疑人。究竟是谁在说谎，又是谁在设局？",
    latest: true,
    hot: true,
  },
  {
    id: "all-in",
    title: "孤注一掷",
    poster:
      "https://readdy.ai/api/search-image?query=Crime%20thriller%20movie%20poster%20with%20a%20glowing%20phone%20screen%20in%20a%20dark%20room%2C%20tense%20mood%2C%20orange%20neon%20reflection%2C%20urban%20night%20atmosphere%2C%20cinematic%20high%20detail&width=400&height=600&seq=ng-poster-04&orientation=portrait",
    category: "电影",
    genres: ["犯罪", "剧情"],
    region: "国产",
    year: 2024,
    director: "申奥",
    cast: ["张艺兴", "金晨", "咏梅"],
    updateDate: "2025-08-30",
    rating: 8.0,
    summary:
      "程序员被高薪招聘骗至境外，卷入一场精心设计的诈骗帝国。在利益与良知的角力中，他与被困的同伴能否找到逃出深渊的唯一出口？",
    latest: true,
  },
  {
    id: "full-river-red",
    title: "满江红",
    poster:
      "https://readdy.ai/api/search-image?query=Historical%20Chinese%20movie%20poster%20of%20an%20armored%20warrior%20standing%20in%20a%20dim%20ancient%20hall%20with%20red%20lanterns%2C%20dramatic%20shadows%2C%20warm%20amber%20tones%2C%20cinematic%20high%20detail&width=400&height=600&seq=ng-poster-05&orientation=portrait",
    category: "电影",
    genres: ["悬疑", "历史"],
    region: "国产",
    year: 2024,
    director: "张艺谋",
    cast: ["沈腾", "易烊千玺", "雷佳音"],
    updateDate: "2025-08-18",
    rating: 7.9,
    summary:
      "南宋绍兴年间，一桩离奇命案牵出惊天内幕。小兵张大与众人被卷入层层迷局，一桩桩悬案背后，是一个关于忠义与家国的惊天计划。",
    hot: true,
  },
  {
    id: "yolo",
    title: "热辣滚烫",
    poster:
      "https://readdy.ai/api/search-image?query=Inspiring%20boxing%20movie%20poster%20of%20a%20female%20boxer%20silhouette%20in%20a%20dim%20gym%20with%20warm%20amber%20light%20and%20dust%20in%20the%20air%2C%20energetic%2C%20cinematic%20high%20detail&width=400&height=600&seq=ng-poster-06&orientation=portrait",
    category: "电影",
    genres: ["喜剧", "剧情"],
    region: "国产",
    year: 2024,
    director: "贾玲",
    cast: ["贾玲", "雷佳音", "张小斐"],
    updateDate: "2025-08-05",
    rating: 7.8,
    summary:
      "一个在生活里处处碰壁的普通人，偶然走进拳击馆，从此开始了一场与自己较劲的漫长修行。赢一次，就够了吗？她用拳头回答了所有质疑。",
  },
  {
    id: "creation-of-gods-2",
    title: "封神第二部",
    poster:
      "https://readdy.ai/api/search-image?query=Epic%20Chinese%20mythology%20movie%20poster%20of%20an%20ancient%20warrior%20in%20ornate%20armor%20before%20a%20stormy%20sky%2C%20golden%20light%20breaking%20through%20clouds%2C%20dramatic%20cinematic%20high%20detail&width=400&height=600&seq=ng-poster-07&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=Epic%20Chinese%20mythology%20battlefield%20with%20ancient%20armored%20warriors%20under%20a%20stormy%20golden%20sky%2C%20mountains%20in%20the%20distance%2C%20dramatic%20cinematic%20wide%20shot%2C%20high%20detail&width=1600&height=900&seq=ng-banner-03&orientation=landscape",
    category: "电影",
    genres: ["奇幻", "动作"],
    region: "国产",
    year: 2025,
    director: "乌尔善",
    cast: ["费翔", "于适", "娜然"],
    updateDate: "2025-10-08",
    rating: 8.5,
    summary:
      "商周大战一触即发，西岐与朝歌的命运在烽火中交锋。英雄挺身而出，神魔各显神通，一场关乎天下苍生的浩劫即将拉开序幕。",
    featured: true,
    latest: true,
    hot: true,
  },
  {
    id: "deep-sea",
    title: "深海",
    poster:
      "https://readdy.ai/api/search-image?query=Dreamy%20animated%20film%20poster%20of%20a%20colorful%20deep%20ocean%20dreamscape%20with%20glowing%20particles%20and%20soft%20warm%20light%2C%20cinematic%20fantasy%2C%20high%20detail&width=400&height=600&seq=ng-poster-08&orientation=portrait",
    category: "电影",
    genres: ["动画", "奇幻"],
    region: "国产",
    year: 2024,
    director: "田晓鹏",
    cast: ["苏鑫", "王亭文"],
    updateDate: "2025-07-22",
    rating: 8.1,
    summary:
      "一个郁郁寡欢的小女孩，在一场意外的海底奇幻旅程中，遇见了形形色色的生命。为了寻找妈妈，她潜入最深的海，也触碰到了自己心底最亮的光。",
  },
  {
    id: "the-knockout",
    title: "狂飙",
    poster:
      "https://readdy.ai/api/search-image?query=Crime%20drama%20poster%20of%20dark%20city%20street%20at%20night%20with%20police%20car%20lights%20and%20orange%20street%20glow%2C%20tense%20moody%20atmosphere%2C%20cinematic%20high%20detail&width=400&height=600&seq=ng-poster-09&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=Moody%20nighttime%20city%20skyline%20with%20rain%20slick%20streets%20and%20warm%20orange%20street%20lamps%2C%20crime%20drama%20atmosphere%2C%20cinematic%20wide%20shot%2C%20high%20detail&width=1600&height=900&seq=ng-banner-02&orientation=landscape",
    category: "电视剧",
    genres: ["犯罪", "剧情"],
    region: "国产",
    year: 2024,
    director: "徐纪周",
    cast: ["张译", "张颂文", "李一桐"],
    updateDate: "2025-10-10",
    rating: 9.0,
    summary:
      "一名基层刑警与一个从鱼贩起家的黑恶势力头目，在二十余年的时光里缠斗不休。正义也许会迟到，但从未缺席。这是一场关于人性与选择的漫长较量。",
    featured: true,
    latest: true,
    hot: true,
  },
  {
    id: "blossoms-shanghai",
    title: "繁花",
    poster:
      "https://readdy.ai/api/search-image?query=Retro%201990s%20Shanghai%20drama%20poster%20with%20neon%20street%20lights%20and%20vintage%20warm%20tones%2C%20elegant%20nighttime%20city%20mood%2C%20cinematic%20high%20detail&width=400&height=600&seq=ng-poster-10&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=Nostalgic%201990s%20Shanghai%20street%20at%20night%20with%20glowing%20warm%20neon%20signs%20and%20rain%20reflections%2C%20elegant%20cinematic%20wide%20shot%2C%20high%20detail&width=1600&height=900&seq=ng-banner-05&orientation=landscape",
    category: "电视剧",
    genres: ["剧情", "爱情"],
    region: "国产",
    year: 2024,
    director: "王家卫",
    cast: ["胡歌", "马伊琍", "唐嫣"],
    updateDate: "2025-09-30",
    rating: 8.7,
    summary:
      "九十年代的上海，机遇与欲望交织。青年阿宝在时代浪潮中沉浮，从一无所有到风光无限，也尝尽了人情冷暖与聚散离合。繁花落尽，方见真心。",
    featured: true,
    latest: true,
  },
  {
    id: "three-body",
    title: "三体",
    poster:
      "https://readdy.ai/api/search-image?query=Sci-fi%20drama%20poster%20of%20a%20giant%20rotating%20ring%20structure%20in%20dark%20space%2C%20cosmic%20scale%2C%20warm%20orange%20glow%2C%20cinematic%20high%20detail&width=400&height=600&seq=ng-poster-11&orientation=portrait",
    category: "电视剧",
    genres: ["科幻", "悬疑"],
    region: "国产",
    year: 2024,
    director: "杨磊",
    cast: ["张鲁一", "于和伟", "陈瑾"],
    updateDate: "2025-09-15",
    rating: 8.9,
    summary:
      "一批科学家的离奇死亡，将物理学界拖入前所未有的恐慌。随着调查深入，一个跨越星际的文明谜题缓缓展开，人类第一次直面来自宇宙深处的凝视。",
    hot: true,
  },
  {
    id: "the-long-season",
    title: "漫长的季节",
    poster:
      "https://readdy.ai/api/search-image?query=Nostalgic%20drama%20poster%20of%20an%20autumn%20forest%20road%20with%20warm%20golden%20mist%2C%20melancholic%20mood%2C%20cinematic%20high%20detail&width=400&height=600&seq=ng-poster-12&orientation=portrait",
    category: "电视剧",
    genres: ["悬疑", "剧情"],
    region: "国产",
    year: 2024,
    director: "辛爽",
    cast: ["范伟", "秦昊", "陈明昊"],
    updateDate: "2025-08-25",
    rating: 9.2,
    summary:
      "一桩尘封多年的碎尸案，让三个老男人在漫长的岁月里始终无法释怀。当真相终于在金色的秋天里浮出水面，他们才明白，命运早已写好了答案。",
    hot: true,
  },
  {
    id: "joy-of-life-2",
    title: "庆余年第二季",
    poster:
      "https://readdy.ai/api/search-image?query=Chinese%20costume%20drama%20poster%20of%20an%20elegant%20young%20warrior%20in%20an%20ancient%20courtyard%20with%20warm%20lantern%20light%2C%20cinematic%20high%20detail&width=400&height=600&seq=ng-poster-13&orientation=portrait",
    category: "电视剧",
    genres: ["古装", "剧情"],
    region: "国产",
    year: 2024,
    director: "孙皓",
    cast: ["张若昀", "李沁", "陈道明"],
    updateDate: "2025-08-12",
    rating: 8.6,
    summary:
      "范闲假死归来，重返京都棋盘。朝堂风云再起，家族、庙堂、江湖的暗流交织，他必须以更深的谋略，去守护心中那份未改的初心。",
    latest: true,
  },
  {
    id: "rose-story",
    title: "玫瑰的故事",
    poster:
      "https://readdy.ai/api/search-image?query=Romantic%20drama%20poster%20of%20an%20elegant%20woman%20silhouette%20in%20soft%20warm%20light%20with%20delicate%20flowers%2C%20graceful%20cinematic%20mood%2C%20high%20detail&width=400&height=600&seq=ng-poster-14&orientation=portrait",
    category: "电视剧",
    genres: ["爱情", "剧情"],
    region: "国产",
    year: 2024,
    director: "汪俊",
    cast: ["刘亦菲", "佟大为", "林更新"],
    updateDate: "2025-07-28",
    rating: 8.0,
    summary:
      "黄亦玫的一生，是一朵玫瑰的盛开与绽放。从青春到成熟，她在爱情、事业与自我之间不断追寻，活出了属于自己的完整人生。",
  },
  {
    id: "my-altay",
    title: "我的阿勒泰",
    poster:
      "https://readdy.ai/api/search-image?query=Nature%20drama%20poster%20of%20vast%20grassland%20and%20snow%20mountains%20at%20golden%20hour%20with%20a%20lone%20nomad%20figure%2C%20serene%20cinematic%20mood%2C%20high%20detail&width=400&height=600&seq=ng-poster-15&orientation=portrait",
    category: "电视剧",
    genres: ["剧情"],
    region: "国产",
    year: 2024,
    director: "滕丛丛",
    cast: ["马伊琍", "周依然", "于适"],
    updateDate: "2025-07-15",
    rating: 8.9,
    summary:
      "少女李文秀回到阿勒泰的牧场，在辽阔的天地间重新认识生活。风吹草低，四季流转，她在与自然的相处中，找到了内心最平静的归处。",
  },
  {
    id: "yaoguai-anthology",
    title: "中国奇谭",
    poster:
      "https://readdy.ai/api/search-image?query=Stylized%20Chinese%20animation%20anthology%20poster%20with%20mystical%20ink%20creatures%20in%20warm%20amber%20tones%2C%20artistic%20fantasy%20style%2C%20high%20detail&width=400&height=600&seq=ng-poster-16&orientation=portrait",
    category: "短片",
    genres: ["动画", "奇幻"],
    region: "国产",
    year: 2024,
    director: "於水",
    cast: ["配音群星"],
    updateDate: "2025-09-08",
    rating: 8.8,
    summary:
      "八个独立成篇的奇幻故事，取材于中国传统志怪与民间传说。水墨、剪纸、定格……多样的动画语言，讲述属于东方想象力的独特浪漫。",
    latest: true,
    hot: true,
  },
  {
    id: "roaming-future",
    title: "漫游未来",
    poster:
      "https://readdy.ai/api/search-image?query=Futuristic%20sci-fi%20short%20film%20poster%20of%20a%20sleek%20neon%20orange%20cityscape%20at%20dusk%2C%20sleek%20modern%20design%2C%20cinematic%20high%20detail&width=400&height=600&seq=ng-poster-17&orientation=portrait",
    category: "短片",
    genres: ["科幻"],
    region: "国产",
    year: 2025,
    director: "林深",
    cast: ["新人演员"],
    updateDate: "2025-10-05",
    rating: 7.6,
    summary:
      "在不远的未来，一座城市拥有了自己的记忆。一个修复记忆的年轻人，在一段即将被删除的梦境里，遇见了这座城市最初的样子。",
    latest: true,
  },
  {
    id: "human-fireworks",
    title: "人间烟火",
    poster:
      "https://readdy.ai/api/search-image?query=Documentary%20short%20film%20poster%20of%20a%20night%20street%20food%20stall%20with%20steam%20and%20warm%20glowing%20lanterns%2C%20cozy%20cinematic%20mood%2C%20high%20detail&width=400&height=600&seq=ng-poster-18&orientation=portrait",
    category: "短片",
    genres: ["剧情"],
    region: "国产",
    year: 2024,
    director: "陈晨",
    cast: ["纪实出镜"],
    updateDate: "2025-08-20",
    rating: 8.3,
    summary:
      "深夜的街边小摊，一碗热汤面温暖着晚归的陌生人。摊主守着三十年的老灶，用最简单的方式，记录着这座城市最真实的人间温度。",
  },
  {
    id: "one-minute-lovers",
    title: "一分钟恋人",
    poster:
      "https://readdy.ai/api/search-image?query=Romantic%20short%20film%20poster%20of%20two%20silhouettes%20under%20a%20warm%20streetlight%20with%20soft%20bokeh%20lights%2C%20tender%20cinematic%20mood%2C%20high%20detail&width=400&height=600&seq=ng-poster-19&orientation=portrait",
    category: "短片",
    genres: ["爱情"],
    region: "日韩",
    year: 2024,
    director: "金敏俊",
    cast: ["新人演员"],
    updateDate: "2025-08-01",
    rating: 7.5,
    summary:
      "每天只在同一分钟相遇的两个陌生人，用一分钟交换彼此的喜怒哀乐。当时间走到尽头，这段短暂的陪伴，会留下怎样的答案？",
  },
  {
    id: "city-of-light",
    title: "城市之光",
    poster:
      "https://readdy.ai/api/search-image?query=Drama%20short%20film%20poster%20of%20a%20night%20city%20skyline%20with%20warm%20glowing%20window%20lights%2C%20cinematic%20melancholic%20mood%2C%20high%20detail&width=400&height=600&seq=ng-poster-20&orientation=portrait",
    category: "短片",
    genres: ["剧情", "犯罪"],
    region: "欧美",
    year: 2024,
    director: "David Moore",
    cast: ["独立主演"],
    updateDate: "2025-07-10",
    rating: 7.7,
    summary:
      "一名深夜出租车司机，搭载着形形色色的乘客穿行在城市灯火之中。每一段短暂的旅途，都藏着一个不为人知的故事与秘密。",
  },
  {
    id: "silent-tide",
    title: "寂静潮汐",
    poster:
      "https://readdy.ai/api/search-image?query=Atmospheric%20sci-fi%20movie%20poster%20of%20a%20lighthouse%20on%20a%20rocky%20shore%20under%20a%20dark%20stormy%20sky%20with%20warm%20orange%20beacon%20light%2C%20cinematic%20high%20detail&width=400&height=600&seq=ng-poster-21&orientation=portrait",
    category: "电影",
    genres: ["悬疑", "科幻"],
    region: "欧美",
    year: 2025,
    director: "Emma Cole",
    cast: ["独立主演"],
    updateDate: "2025-10-02",
    rating: 8.4,
    summary:
      "一座与世隔绝的灯塔，守护着海岸线上最后的秘密。当潮水退去，礁石间浮现的，并非沉船残骸，而是一段被刻意遗忘的真相。",
    latest: true,
    hot: true,
  },
  {
    id: "the-samurai-path",
    title: "武士之道",
    poster:
      "https://readdy.ai/api/search-image?query=Japanese%20samurai%20drama%20poster%20of%20a%20lone%20swordsman%20in%20a%20bamboo%20grove%20at%20dusk%20with%20warm%20orange%20light%2C%20cinematic%20high%20detail&width=400&height=600&seq=ng-poster-22&orientation=portrait",
    category: "电影",
    genres: ["动作", "历史"],
    region: "日韩",
    year: 2024,
    director: "佐藤健一",
    cast: ["独立主演"],
    updateDate: "2025-07-30",
    rating: 8.1,
    summary:
      "战乱年代的漂泊武士，在复仇与救赎之间艰难前行。竹影摇曳，刀光凛冽，他终于在最后一战中，悟出了武士之道的真正含义。",
  },
];